import axios from 'axios'
import {
  Message,
  MessageBox
} from 'sw-ui'
import store from '../store'
import config from "@/config";
import {
  removeToken
} from "./auth";
import { login, checkIfTokenValid } from '../utils/index'
import * as Cookies from "js-cookie";
// 非登陆状态，清空token
if (!Cookies.get("isLogin")) {
  store.commit('SET_TOKEN', '');
}
const service = axios.create({
  //baseURL: baseurl.BASE_BACK_API, // api 的 base_url
  timeout: 1000 * 300, // 请求超时时间
})
service.interceptors.request.use(
  config => {
    let token = `${store.state.user.token}`;
    // let token = `eyJhbGciOiJSUzUxMiJ9.eyJBVFRSX3VzZXJObyI6InNtYXJ0YWRtaW4iLCJzdWIiOiJzbWFydGFkbWluIiwiaXNzIjoiY2FzLWkuaG51c3QuZWR1LmNuIiwiQVRUUl9pZGVudGl0eVR5cGVJZCI6IjEiLCJBVFRSX2FjY291bnRJZCI6IjEiLCJBVFRSX3VzZXJJZCI6IjEiLCJBVFRSX25hbWUiOiLmmbrmhafmoKHlm63nrqHnkIblkZgiLCJBVFRSX2lkZW50aXR5VHlwZUNvZGUiOiJhZG1pbiIsIkFUVFJfaWRlbnRpdHlUeXBlTmFtZSI6IueuoeeQhiIsIkFUVFJfYWNjb3VudE5hbWUiOiJzbWFydGFkbWluIiwiQVRUUl9vcmdhbml6YXRpb25OYW1lIjoi5rmW5Y2X56eR5oqA5aSn5a2mIiwiQVRUUl91c2VyTmFtZSI6IuaZuuaFp-agoeWbreeuoeeQhuWRmCIsImxhbmciOiJlbiIsImV4cCI6MTY5MzAxOTI3MiwiQVRUUl9vcmdhbml6YXRpb25JZCI6IjAiLCJBVFRSX3VpZCI6InNtYXJ0YWRtaW4iLCJpYXQiOjE2OTI4NDY0NzIsImp0aSI6IklELVRva2VuLTQwODUtVGs5cGdpMVhSYkM3OVM0Z3BjVUZGLUJ4ZjktRlBhRUkiLCJyZXEiOiJodHRwczovL3BvcnRhbC1pLmhudXN0LmVkdS5jbi8iLCJBVFRSX29yZ2FuaXphdGlvbkNvZGUiOiIwIn0.cdS2wTyacQcHyKWssdasX2HioOEdT1hQyFQlY9AW2iMjduPryuSlJFwba15Z1p-ksBqv61naacDL0ZBP9_VlFmxnHf8CcHteGbkJy1qVKgoJrmhCxU8jqYXnJBwP5YRDVv1uKDKdahIDDHtExY5q-a6DZECkF0g0kOPxhQULL0TUb70L0xxQ1jmyMJrWm_KMDt1TifBxTZqj-6F5lxxshqNB9MbiDRhhePHtX5oRsW2TH6g2MloO94Ld5rrfVgBurlj0giJ79uqe-q9mXVF8lxapzGzuibFM8xmUxh9Dbbz4JiTXomEL3ZGMFiR7WwcDJQ7wLq3Rr989yv98L0vN4Q`
    // console.log( store.state.user)
    // if( store.state.user.token == null ){
    // 	login()
    // }
    if (!store.getters.token && getQueryString('token')) {
      let token = getQueryString('token');

      // return console.log(token)
      store.commit('SET_TOKEN', token)
    }
    if (store.getters.token) {
      config.headers['Authorization'] = `Bearer ${store.state.user.token}` // 让每个请求携带自定义token 请根据实际情况自行修改
    }
    //
    // let token = `${store.state.user.token}`;
    // let token = 'eyJhbGciOiJSUzUxMiJ9.eyJzdWIiOiIxOTkzMDAwMDMwIiwiaXNzIjoidWlzLnBhYXMubndwdS5lZHUuY24iLCJBVFRSX2lkZW50aXR5VHlwZUlkIjoiVDAxIiwiQVRUUl9hY2NvdW50SWQiOiIxOTkzMDAwMDMwIiwiQVRUUl91c2VySWQiOiIxOTkzMDAwMDMwIiwiQVRUUl9uYW1lIjoi6IGC546J5bOwIiwiQVRUUl9pZGVudGl0eVR5cGVDb2RlIjoiVDAxIiwiQVRUUl9pZGVudGl0eVR5cGVOYW1lIjoi5pWZ6IGM5belIiwiQVRUUl9hY2NvdW50TmFtZSI6IjE5OTMwMDAwMzAiLCJBVFRSX29yZ2FuaXphdGlvbk5hbWUiOiLmlbDlrabkuI7nu5_orqHlrabpmaIiLCJBVFRSX3VzZXJOYW1lIjoi6IGC546J5bOwIiwiZXhwIjoxNjg3NTEwNzIwLCJBVFRSX29yZ2FuaXphdGlvbklkIjoiMDY1MDAiLCJpYXQiOjE2ODczMzc5MjAsImp0aSI6IklELVRva2VuLTE2ODc2LWs3Tm5PSU8tcVJjUFVzWHA0ZlFuajNOLTRyd29QUTZiIiwicmVxIjoicG9ydGFsLXNlcnZpY2UtY2VudGVyIiwiQVRUUl9vcmdhbml6YXRpb25Db2RlIjoiMDY1MDAifQ.qzK2kT0RI7bi2KPBIQSDsqNRgSPCXSi_5G-KtSZ5dn8W8EgGwv68USQvLR1oR_pdaLb3O5gYun7t2x2YV-KPM-8aZw11Fxu8U-Yp3mDqgKDuduXmzCzbDnCoSUCFIsa1ongbw-2mVcbHtSIzak4lm_vhcIpx8D7yKaIXzJOR2T0';
    //console.log(token,config.headerType);
    switch (config.headerType) {
      // 门户请求头
      case "portal":
        config.headers["X-Device-Info"] = "PC";
        config.headers["X-Terminal-Info"] = "PC";
        config.headers["X-Id-Token"] = token;
        break;
      // 游客请求头
      case "open":
        config.headers["X-Device-Info"] = "PC";
        config.headers["X-Terminal-Info"] = "PC";
        break;
      // 消息请求头
      case "message":
        config.headers["X-Id-Token"] = token;
        break;
      // 事务请求头
      case "task":
        config.headers["Authorization"] = token;
        break;
      // 认证请求头
      case "cas":
        config.headers["Authorization"] = token;
        break;
      // 请求publicKey
      case "publicKey":
        break;
      // 表单、流程、打印模版设计
      case "forward":
        config.headers["X-FORWARD-ID-TOKEN"] = token;
        break;
      // 部门组织组、群组、角色
      case "admin":
        config.headers["Authorization"] = `Bearer ${token}`;
        break;
      // 西工大移动跳转页面
      case "xgd":
        config.headers["X-Device-Info"] = "mobile";
        config.headers["X-Terminal-Info"] = "mobile";
        config.headers["X-Id-Token"] = config.token;
        break;
      // 西外移动跳转页面
      case "xisu":
        config.headers["X-Device-Info"] = "mobile";
        config.headers["X-Terminal-Info"] = "mobile";
        config.headers["X-Id-Token"] = config.token;
        break;
      // 默认游客请求头
      default:
        config.headers["X-Device-Info"] = "PC";
        config.headers["X-Terminal-Info"] = "PC";
        break;
    }
    //
    let url = config.url
    // get参数编码
    if (config.method === 'get' && config.params) {
      url += '?'
      let keys = Object.keys(config.params)
      for (let key of keys) {
        if (config.params[key]) {
          url += `${encodeURIComponent(key)}=${encodeURIComponent(config.params[key])}&`
        }
      }
      url = url.substring(0, url.length - 1)
      config.params = {}
    }
    config.url = url
    return config
  },
  error => {
    // Do something with request error
    console.log(error) // for debug
    Promise.reject(error)
  }
)

//response 拦截器
service.interceptors.response.use(
  response => {
    // debugger
    if (response.code == '-1001' || response.code == '-1' || response.data.code == '-1001' || response.data.code == '-1') {
      // login()
      let currentUrl = window.location.href;
      if (config.LOGIN_WAY === "uniAuth") {
        let uniAuthConfig = JSON.parse(config.AUTH_SETTING);
        uniAuthConfig.state = GetRandomNum(1, 999999);
        uniAuthConfig.nonce = GenerateMixed(6);
        store.commit("SET_UNIAITH_NONCE", uniAuthConfig.nonce);
        console.log("uniAuthConfig", uniAuthConfig);
        url = `${uniAuthConfig.url}idtoken/login?client_id=${uniAuthConfig.client_id}&redirect_uri=${currentUrl}&state=${uniAuthConfig.state}&nonce=${uniAuthConfig.nonce}`;
        window.location.href = url;
      } else {
        // cas 认证
        window.location.href = `${config.casUrl}login?service=${currentUrl}`;
      }
    }
    return response.data;
  },
  error => {
    // debugger
    if (error.response) {
      if (error.response.status == 403) {
        // removeToken()
        login()
      } else {
        Message({
          message: error.response.data.message,
          type: 'error',
          duration: 5 * 1000,
        })
      }
    }
    return Promise.reject(error)
  }
)

function getQueryString(name) {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
  var r = window.location.search.substr(1).match(reg);
  if (r != null) {
    return unescape(r[2]);
  }
  return null;
}

export default service